import { render, staticRenderFns } from "./addEditDetails.vue?vue&type=template&id=8049daf0&scoped=true"
import script from "./addEditDetails.vue?vue&type=script&lang=js"
export * from "./addEditDetails.vue?vue&type=script&lang=js"
import style0 from "./addEditDetails.vue?vue&type=style&index=0&id=8049daf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8049daf0",
  null
  
)

export default component.exports